import React from "react";

import './Carousel.css'

function Slideshow(){
    return(
            <img className='caraousel' src='https://ethereum.org/static/4d030a46f561e5c754cabfc1a97528ff/3ba1a/impact_transparent.webp' />
    );
}

export default Slideshow;